import { Component, OnInit,Input } from '@angular/core';
import * as _ from "lodash";
@Component({
  selector: 'app-booksFilter',
  templateUrl: './booksFilter.component.html',
  styleUrls: ['./booksFilter.component.css']
})
export class BooksFilterComponent implements OnInit {
  @Input() data: any;
  public selectedBookTypeIndex = undefined;
  public booksFilterTypes = [{ 'name': 'All', 'icon': 'icon-All-2' }, { 'name': 'ELE', 'icon': 'icon-ELE' }, { 'name': 'EBE', 'icon': 'icon-EBE' }];
  public list = [];
  constructor() { }

  ngOnInit() {
 
    this.booksFilterTypes = this.data.popupProps.filterList;
    this.list = this.data.popupProps.curComp.filterBooksArr;  
    if(this.list.length == 0 && this.data.popupProps.curComp.filterUpdatingState){
      this.list = this.data.popupProps.curComp.allFiltersList;
    }
  }

  showGridView(ind,item,ev){
       var idx =  _.findIndex(this.list, function(o) { return o == item; })
      if (idx > -1) {
        this.list.splice(idx, 1);
      }
      else {
        this.list.push(item);
      }
    this.data.popupProps.curComp.updateFilter(ind,this.list);
  }

  isChecked(ind,item){
   let index =  _.findIndex(this.list, function(o) { return o == item; });
    if(index != -1){
      // ******* for all ******
      // if(this.list.length == this.booksFilterTypes.length){
      //   return false;
      // }else{
      //   return true;
      // }

      return true;
    }
    else{
      return false;
    }
  }

  isAllChecked(){
   if(this.list.length == this.booksFilterTypes.length){
    //  this.list = [];
    this.list = JSON.parse(JSON.stringify(this.booksFilterTypes));
     return true;
   }
  }
  selectAllOptions(){
    //  this.list = [];
    this.list = JSON.parse(JSON.stringify(this.booksFilterTypes));
     this.data.popupProps.curComp.updateFilter(0,this.list);
  }
}



// WEBPACK FOOTER //
// ./src/app/shelf/popups/booksFilter/booksFilter.component.ts